import { fullName } from "@/common/utils";

export default {
	install(Vue) {
		Vue.filter("fullName", function (name) {
			return fullName(name);
		});
	}
};
